import { render, staticRenderFns } from "./VMap.vue?vue&type=template&id=220bd680&"
import script from "./VMap.vue?vue&type=script&lang=js&"
export * from "./VMap.vue?vue&type=script&lang=js&"
import style0 from "./VMap.vue?vue&type=style&index=0&id=220bd680&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports